import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.users.title',
    defaultMessage: 'Users',
    description: 'title of the users page',
  },
  user: {
    create: {
      button: {
        id: 'pages.users.create.button',
        defaultMessage: 'Create',
        description: 'title of the create user button',
      },
      title: {
        id: 'pages.users.create.title',
        defaultMessage: 'Create user',
        description: 'title of the create user drawer',
      },
    },
  },
  feedback: {
    userCreated: {
      id: 'pages.users.feedback.userCreated',
      defaultMessage: 'User created',
      description: 'success feedback message of the user create action',
    },
    userNotCreated: {
      id: 'pages.users.feedback.userNotCreated',
      defaultMessage: 'User could not be created',
      description: 'error feedback message of the user create action',
    },
  },
  subNavigation: {
    overview: {
      id: 'pages.users.subNavigation.overview',
      defaultMessage: 'Overview',
      description: 'label of the overview tab on the users page',
    },
    invites: {
      id: 'pages.users.subNavigation.invites',
      defaultMessage: 'Invites',
      description: 'label of the invites tab on the users page',
    },
  },
};

export default defineMessages(translations);
